import React, { useState, useEffect } from "react";

import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import {
  CardMedia,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import CardImageButton from "../../../components/cards/CardImageButton";
import useMarketPlacesController from "./MarketplacesController";
import {
  useCnpj,
  useMarketplacesConectados,
} from "../../../context/integracao/MarketplacesContext";

import "./Marketplaces.css";

const MarketplacesTabAvancado = ({ ...props }) => {
  // Filtros
  const { marketplacesConectados } = useMarketplacesConectados();
  const { cnpj } = useCnpj();

  const [desvincularAnuncios, setDesvincularAnuncios] = useState("false");
  const [excluirMarketplaceTela, setExcluirMarketplaceTela] = useState(null);

  // Adiciona as funções vindas do MarketPlacesController
  const { desvincularMarketplace } = useMarketPlacesController();

  const colorRed = "#e04854";

  // Carrega todos os campos específicos que iniciam com a tela (usando useEffect para serem carregados somente uma vez)

  const SweetAlertReact = withReactContent(Swal);

  useEffect(() => {
    if (excluirMarketplaceTela === null) return;
    SweetAlertReact.fire({
      showClass: {
        popup: "swal2-noanimation",
        backdrop: "swal2-noanimation",
      },
      title: (
        <legend style={{ width: "550px" }}>Desconectar Marketplaces</legend>
      ),
      html: (
        <Grid container spacing={2}>
          <Grid item lg={4} xs={4}>
            <CardMedia
              component="img"
              height="160"
              image={excluirMarketplaceTela.picture}
              key={"media_"}
            />
          </Grid>
          <Grid item lg={4} xs={4}>
            <FormControl component="fieldset">
              <FormLabel>
                <strong>Deseja excluir os anúncios?</strong>
              </FormLabel>
              <RadioGroup
                value={desvincularAnuncios}
                key="RadioGroupDesvincular"
                aria-label="desvincular"
                name="desvincularName"
                onChange={(event) => {
                  setDesvincularAnuncios(event.target.value);
                }}
              >
                <FormControlLabel
                  key="FormControlLabelManter"
                  value={"false"}
                  control={<Radio />}
                  label="Manter"
                  id="FormControlLabelManter"
                />
                <FormControlLabel
                  key="FormControlLabelExcluir"
                  value={"true"}
                  control={<Radio />}
                  label="Excluir"
                  id="FormControlLabelExcluir"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item lg={4} xs={4} height="100%">
            <Button
              key={"btn_desvincular_confirmar_" + excluirMarketplaceTela.id}
              style={{
                backgroundColor: colorRed,
                height: "40%",
              }}
              variant="contained"
              id="title-button"
              onClick={func_btn_desvincular_confirmar}
            >
              Desconectar
            </Button>
          </Grid>
        </Grid>
      ),
      showConfirmButton: false,
      showCloseButton: true,
      width: "700px",
    });
    // eslint-disable-next-line
  }, [excluirMarketplaceTela, desvincularAnuncios]);

  // function dos botões
  const func_btn_desvincular_confirmar = async () => {
    let result = await desvincularMarketplace(
      cnpj,
      excluirMarketplaceTela.id,
      "true" === desvincularAnuncios
    );
    if (result.success) {
      Swal.fire({
        icon: "success",
        text: "Marketplace desvinculado com sucesso!",
        showConfirmButton: false,
        timer: 3000,
        willClose: () => {
          sessionStorage.removeItem("marketplaceId");
          window.location.reload();
        },
      });
      sessionStorage.removeItem("marketplaceId");
    } else
      Swal.fire({
        icon: "error",
        text: result.error,
        showConfirmButton: false,
        timer: 3000,
      });
  };

  // Abaixo será feito somente a construção da tela

  // Botões de conectar/desconectar/configurações dos marketplaces

  return (
    <>
      <h3>Deseja parar de vender em um dos marketplaces?</h3>
      <Grid container spacing={2} key="grid_desconectar_sweetAlert">
        {marketplacesConectados.map((value, index) => {
          return (
            <Grid item key={"grid_item_desconectar_" + value.id}>
              <CardImageButton
                image={value.picture}
                itemId={"card_" + index}
                key={"img_" + value.id}
                imgStyle={{ width: "230px", height: "160px" }}
              >
                <Button
                  key={"btn_desconectar_" + value.id}
                  onClick={() => {
                    setExcluirMarketplaceTela(value);
                  }}
                  style={{ backgroundColor: colorRed }}
                >
                  Desconectar
                </Button>
              </CardImageButton>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default MarketplacesTabAvancado;
